import { render } from "./PopUpEditAiGeneratedQuestion.vue?vue&type=template&id=b4bfbd1e&scoped=true"
import script from "./PopUpEditAiGeneratedQuestion.vue?vue&type=script&lang=js"
export * from "./PopUpEditAiGeneratedQuestion.vue?vue&type=script&lang=js"

import "./PopUpEditAiGeneratedQuestion.vue?vue&type=style&index=0&id=b4bfbd1e&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b4bfbd1e"]])

export default __exports__